import { ActivityHistoryCard, useModal } from '@europrocurement/flexy-components';
import { addNoteIcon } from '@europrocurement/l2d-icons';
import { useSelectedDossierContext } from '@europrocurement/l2d-modules/modules/Dossiers/providers/SelectedDossierContext';
import ActivitiesCardContent from '@europrocurement/l2d-modules/modules/Dossiers/components/detail/ActivitiesCardContent/ActivitiesCardContent';
import useActivitiesHook from '@europrocurement/l2d-modules/modules/Dossiers/hooks/useActivitiesHook';
import { useTheme } from '@mui/material';
import React, { useEffect, useMemo } from 'react';
import { DossierOpenSearch } from '@europrocurement/l2d-domain';
import SelectedDossierProvider from '@europrocurement/l2d-modules/modules/Dossiers/providers/SelectedDossierProvider';

type ModalListNotesProps = {
    dossierProps: DossierOpenSearch;
};

const ModalListNotes: React.FunctionComponent<ModalListNotesProps> = function ({ dossierProps }) {
    const { modalActions } = useModal();

    const { activities, activitiesLoading, handleAddNote, handleEditNote, handleDeleteNote } =
        useActivitiesHook({
            // Re-open the modal on success
            actionOnSuccess: () => {
                modalActions.call(
                    <SelectedDossierProvider>
                        <ModalListNotes dossierProps={dossierProps} />
                    </SelectedDossierProvider>,
                );
            },
            defaultMemoClient: true,
        });

    const { dossier, notesLoading, notesError, setDossier } = useSelectedDossierContext();
    const { palette } = useTheme();

    useEffect(() => {
        if (!dossier) {
            setDossier(dossierProps);
        }
    });

    const actions = useMemo(
        () => [
            {
                id: 'add-note',
                label: 'Ajouter une note',
                shortLabel: 'Ajouter',
                icon: addNoteIcon,
                onClick: handleAddNote,
                variant: 'text' as const,
                color: palette.grey[700],
            },
        ],
        [handleAddNote, palette.grey],
    );
    return (
        <ActivityHistoryCard actions={actions}>
            <ActivitiesCardContent
                activities={activities.filter((note) => note.memoClient)}
                onEditNote={handleEditNote}
                onDeleteNote={handleDeleteNote}
                activitiesLoading={activitiesLoading}
                notesLoading={notesLoading}
                notesError={notesError}
            />
        </ActivityHistoryCard>
    );
};

export default ModalListNotes;
